import apiEndPoints from "../../../routeConfig";
import { ApiService } from "../../../../service/api.service";
import { attempt } from "../../../../service/apiResult";

const apiService = new ApiService();

/** Products the API still exposes as offerable (active finance-based EI provider). */
export const isOfferableFinancialProduct = (product) =>
  Boolean(product?.id) && product.active !== false;

export const filterOfferableFinancialProducts = (products) =>
  (Array.isArray(products) ? products : []).filter(isOfferableFinancialProduct);

/** User personas that can be selected when creating or editing a subscription plan. */
export const isSelectableUserPersona = (userType) =>
  (userType?.status || '').toString().toUpperCase() === 'ACTIVE';

export const filterSelectableUserPersonas = (userTypes) =>
  (Array.isArray(userTypes) ? userTypes : []).filter(isSelectableUserPersona);

export const subscriptionCreateOrUpdate = async (data, editMode, id) => {
  const url = editMode === true
    ? `${apiEndPoints.subscriptionCreateOrUpdate}/${id}`
    : `${apiEndPoints.subscriptionCreateOrUpdate}`;

  return attempt(() => (editMode === true
    ? apiService.update(url, data)
    : apiService.post(url, data)));
}

export const getAllSubscription = async (page = 0, size = 10) => {
  try {
    const response = await apiService.get(`${apiEndPoints.getAllSubscription}?page=${page}&size=${size}`);
    return response.data;
  } catch (error) {
    return error;
  }
};

export const subscriptionGetById = async (id) => {
  let result;
  await apiService.get(`${apiEndPoints.subscriptionGetById}/${id}`)
    .then((response) => {
      result = response.data;
    })
    .catch(error => {
      result = error;
    });
  return result;
};

export const deleteSubscription = async (id) =>
  attempt(() => apiService.delete(`${apiEndPoints.deleteSubscription}/${id}`, ''));

export const subscriptionPatchApi = async (id, statusUpdate) =>
  attempt(() => apiService.patch(`${apiEndPoints.subscriptionPatchApi}/${id}/status/${statusUpdate}`, ''));

// Returns an { success, data } result: callers gate on `success`, and a failure
// carries the reason instead of being indistinguishable from an empty payload.
export const subscriptionMetaData = async () =>
  attempt(async () => (await apiService.get(`${apiEndPoints.subscriptionMetaData}`)).data);

export const currenciesMetaData = async () => {
  let result;
  await apiService.get(`${apiEndPoints.currenciesMetaData}`)
    .then((response) => {
      result = response;
    })
    .catch(error => {
      result = error;
    });
  return result;
};

export const getFinancialSupportProducts = async () => {
  try {
    const response = await apiService.get(`${apiEndPoints.subscriptionMetaData}`);
    return filterOfferableFinancialProducts(response.data?.financialSupportProducts || []);
  } catch (error) {
    console.error('Error fetching financial support products:', error);
    return [];
  }
};